import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import HeaderThin from 'app/components/layout/HeaderThin';
import SectionGroup from 'app/components/general/SectionGroup';
import SchemaForm from 'app/components/general/SchemaForm';

import { parseAmount, unformatAmount } from 'app/utils/parsers';
import * as subscriptionPaymentActions from 'app/ducks/subscriptionPayments/actions';
import * as refundActions from 'app/ducks/refunds/actions';
import * as loadingSelectors from 'app/ducks/loading/selectors';
// import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as subscriptionPaymentSelectors from 'app/ducks/subscriptionPayments/selectors';
import * as refundSelectors from 'app/ducks/refunds/selectors';
import { IMatchPayment } from 'app/ducks/matchPayments/types';

const formSchema = {
  type: 'object',
  required: ['amount'],
  properties: {
    amount: {
      type: 'string',
      title: 'Amount',
      inputType: 'currency',
    },
    reason: {
      type: 'string',
      title: 'Refund Reason (Optional)',
    },
  },
};

const uiSchema = {
  amount: { 'ui:field': 'currency' },
};

interface IRefundPaymentProps {
  appReady: boolean;
  actions: any;
  match: any;
  afterSubmit: Function;
  subscriptionPayments: any;
  refunds: any;
  matchPayment: IMatchPayment;
  errors: any;
}

interface IRefundPaymentState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  errors: any;
}

const selector = (state): any => ({
  appReady: loadingSelectors.appReady(state),
  subscriptionPayments: subscriptionPaymentSelectors.getSubscriptionPayments(state),
  refunds: refundSelectors.getRefunds(state),
  errors: {
    ...state.refunds.backendErrors,
  },
});

const actionCreators = _.merge(subscriptionPaymentActions, refundActions);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class RefundPayment extends React.Component<
IRefundPaymentProps,
IRefundPaymentState
> {
  static defaultProps: IRefundPaymentProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    matchPayment: undefined,
    subscriptionPayments: undefined,
    afterSubmit: undefined,
    errors: undefined,
  };

  state: IRefundPaymentState = {
    originalFormData: {},
    formData: {
      amount: parseAmount(this.props.matchPayment.amount),
      reason: '',
    },
    changed: true,
    saved: false,
    errors: {},
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed) {
      return {
        ...prevState,
        errors: nextProps.errors,
      };
    }
    return null;
  }

  isValid = (): boolean => !_.isEmpty(this.props.matchPayment?.subscriptionPayment?.id) && _.isEmpty(this.state.errors) && this.state.changed;

  handleChange = (e): void => {
    const changed = true;
    this.setState(() => ({
      formData: e.formData,
      errors: [],
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleSubmit = (e): void => {
    if (this.isValid()) {
      const payload = {
        matchPayment: {
          id: this.props.matchPayment?.id,
        },
        subscriptionPayment: {
          id: this.props.matchPayment?.subscriptionPayment?.id,
        },
        amount: unformatAmount(this.state.formData.amount) * 100,
        refundReason: this.state.formData.reason,
        refundType: 'match-payment',
      };
      this.props.actions.createRefund(payload, this.props.afterSubmit);
    }
    this.setState({ changed: true });
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="form-description">
              This will debit your association bank account and then refund the money back to the credit/debit card that paid for this match payment.
            </div>
          </div>
        </div>
        <div className="row margin-top">
          <div className="col">
            <SchemaForm
              uiSchema={uiSchema}
              schema={formSchema}
              handleChange={this.handleChange}
              handleError={this.handleError}
              handleSubmit={this.handleSubmit}
              formData={this.state.formData}
              errors={this.props.errors}
              liveValidate={this.state.changed}
              isValid={this.isValid()}
              isLoading={this.props.refunds.isSaving}
              hasSaved={this.props.refunds.hasSaved}
              hasFailed={this.props.refunds.hasFailed}
              originalFormData={this.state.originalFormData}
              buttonText={`Refund ${this.state.formData.amount}`}
            />
          </div>
        </div>
      </div>
    );
  }
}
